'use client'

import { createContext, Dispatch, SetStateAction } from 'react'

import {
  PaymentErrorCode,
  PaymentNavigationDto,
} from '@marketplace-web/checkout-payments/checkout-payments-options-data'

import { SingleCheckoutModel, UpdateSingleCheckoutArgs } from '../types/checkout'

export type CheckoutErrors = {
  paymentMethodError?: string
  shippingAddressError?: string
  shippingError?: string
  shippingContactError?: string
}

export type SingleCheckoutErrorModel = {
  code?: PaymentErrorCode | string
  type?: string
  message?: string
  extraData?: {
    navigation?: PaymentNavigationDto
  }
}

export type CheckoutContextType = {
  isLoading: boolean
  error: SingleCheckoutErrorModel | null
  checkoutData: SingleCheckoutModel | undefined
  checkoutId: string | undefined
  orderId: string | undefined
  orderType: string | undefined
  saveCardChecked: boolean | undefined
  validationErrors: CheckoutErrors
  paymentOptionsIsOpen: boolean
  setValidationErrors: Dispatch<SetStateAction<CheckoutErrors>>
  setSaveCardChecked: (payload: boolean) => void
  fetchCheckout: () => void
  refetchCheckout: () => void
  updateCheckout: (payload: UpdateSingleCheckoutArgs) => void
  refreshPurchase: () => void
  setPaymentOptionsIsOpen: (value: boolean) => void
  shouldRenderGlobalLoader: boolean
  isItemRemovingLoading: boolean
}

const CheckoutContext = createContext<CheckoutContextType | undefined>(undefined)

export default CheckoutContext
